import { schemes, zSchema } from "@zeal/common";

const postAccrualPolicyUsageEmployeeWLSchema = zSchema.object({
  employeeID: schemes.mongoObjectId(),
  correction: zSchema.boolean().optional().default(false),
  start_date: schemes.isoDate(),
  end_date: schemes.isoDate(),
  amount: zSchema.number(),
});

export const postAccrualPolicyUsageWLRequestSchema = zSchema.object({
  companyID: schemes.companyID(),
  id: schemes.mongoOrUuid(),
  employees: zSchema
    .array(postAccrualPolicyUsageEmployeeWLSchema)
    .min(1, "At least one employee usage entry is required"),
});

export type TPostAccrualPolicyUsageWLRequestSchema = zSchema.infer<
  typeof postAccrualPolicyUsageWLRequestSchema
>;

export const postAccrualPolicyUsageWLResultItemSchema = zSchema.object({
  companyID: schemes.companyID(),
  policyID: zSchema.string(),
  employeeID: schemes.mongoObjectId(),
  correction: zSchema.boolean(),
  amount: zSchema.number(),
  start_date: zSchema.string(),
  end_date: zSchema.string(),
});

export const postAccrualPolicyUsageWLResponseSchema = zSchema.object({
  results: zSchema.array(postAccrualPolicyUsageWLResultItemSchema),
});

export type TPostAccrualPolicyUsageWLResponseSchema = zSchema.infer<
  typeof postAccrualPolicyUsageWLResponseSchema
>;
